import React from 'react';
import Select from 'react-select';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import FormHelper from '../form.js';
import {ButtonValidation, ButtonCancel} from '../../../../component/Button.js';

const options_permission = [
  { value: "READ", label: "READ" },
  { value: "ADD", label: "ADD" },
  { value: "EDIT", label: "EDIT" },
  { value: "DELETE", label: "DELETE" },
]

const options_permission_tenant = [
  { value: "READ", label: "READ" },
  { value: "EDIT", label: "EDIT" },
]

export default class ModalRole extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alias                     : props.data.alias,
      name                      : props.data.name,
      description               : props.data.description,
      asset_permission          : props.data.asset_permission,
      asset_status_permission   : props.data.asset_status_permission,
      asset_type_permission     : props.data.asset_type_permission,
      booking_permission        : props.data.booking_permission,
      business_model_permission : props.data.business_model_permission,
      city_coverage_permission  : props.data.city_coverage_permission,
      confirmation_permission   : props.data.confirmation_permission,
      contact_Permission        : props.data.contact_Permission,
      departement_permission    : props.data.departement_permission,
      location_permission       : props.data.location_permission,
      message_permission        : props.data.message_permission,
      note_permission           : props.data.note_permission,
      photo_permission          : props.data.photo_permission,
      reminder_permission       : props.data.reminder_permission,
      role_permission           : props.data.role_permission,
      service_permission        : props.data.service_permission,
      site_permission           : props.data.site_permission,
      site_status_permission    : props.data.site_status_permission,
      site_type_permission      : props.data.site_type_permission,
      tenant_permission         : props.data.tenant_permission,
      tracking_permission       : props.data.tracking_permission,
      user_permission           : props.data.user_permission,
      vendor_permission         : props.data.vendor_permission,
      work_permission           : props.data.work_permission,
    }
    this.modalAction = this.modalAction.bind(this)
  }

  modalAction() {
    const {mode, register, update} = this.props
    if(!FormHelper.ValidateForm(this.state)) {
      return
    }

    let data = {
      // alias                     : this.state.alias,
      name                      : this.state.name,
      description               : this.state.description,
      asset_permission          : this.state.asset_permission,
      asset_status_permission   : this.state.asset_status_permission,
      asset_type_permission     : this.state.asset_type_permission,
      booking_permission        : this.state.booking_permission,
      business_model_permission : this.state.business_model_permission,
      city_coverage_permission  : this.state.city_coverage_permission,
      confirmation_permission   : this.state.confirmation_permission,
      contact_Permission        : this.state.contact_Permission,
      departement_permission    : this.state.departement_permission,
      location_permission       : this.state.location_permission,
      message_permission        : this.state.message_permission,
      note_permission           : this.state.note_permission,
      photo_permission          : this.state.photo_permission,
      reminder_permission       : this.state.reminder_permission,
      role_permission           : this.state.role_permission,
      service_permission        : this.state.service_permission,
      site_permission           : this.state.site_permission,
      site_status_permission    : this.state.site_status_permission,
      site_type_permission      : this.state.site_type_permission,
      tenant_permission         : this.state.tenant_permission,
      tracking_permission       : this.state.tracking_permission,
      user_permission           : this.state.user_permission,
      vendor_permission         : this.state.vendor_permission,
      work_permission           : this.state.work_permission,
    }

    if(mode === "modal_add") {
      register(data);

    } else {
      data.alias = this.state.alias
      update(data)
    }
  }

  componentDidUpdate(prevProps) {
    let new_state = {}
    if(this.props.isModal !== prevProps.isModal) {
      if(this.props.mode === 'modal_update') {
        new_state = {
          alias                     : this.props.data.alias,
          name                      : this.props.data.name,
          description               : this.props.data.description,
          asset_permission          : this.props.data.asset_permission,
          asset_status_permission   : this.props.data.asset_status_permission,
          asset_type_permission     : this.props.data.asset_type_permission,
          booking_permission        : this.props.data.booking_permission,
          business_model_permission : this.props.data.business_model_permission,
          city_coverage_permission  : this.props.data.city_coverage_permission,
          confirmation_permission   : this.props.data.confirmation_permission,
          contact_Permission        : this.props.data.contact_Permission,
          departement_permission    : this.props.data.departement_permission,
          location_permission       : this.props.data.location_permission,
          message_permission        : this.props.data.message_permission,
          note_permission           : this.props.data.note_permission,
          photo_permission          : this.props.data.photo_permission,
          reminder_permission       : this.props.data.reminder_permission,
          role_permission           : this.props.data.role_permission,
          service_permission        : this.props.data.service_permission,
          site_permission           : this.props.data.site_permission,
          site_status_permission    : this.props.data.site_status_permission,
          site_type_permission      : this.props.data.site_type_permission,
          tenant_permission         : this.props.data.tenant_permission,
          tracking_permission       : this.props.data.tracking_permission,
          user_permission           : this.props.data.user_permission,
          vendor_permission         : this.props.data.vendor_permission,
          work_permission           : this.props.data.work_permission,
        }
      } else {
        new_state = {
          alias                     : "",
          name                      : "",
          description               : "",
          asset_permission          : [],
          asset_status_permission   : [],
          asset_type_permission     : [],
          booking_permission        : [],
          business_model_permission : [],
          city_coverage_permission  : [],
          confirmation_permission   : [],
          contact_Permission        : [],
          departement_permission    : [],
          location_permission       : [],
          message_permission        : [],
          note_permission           : [],
          photo_permission          : [],
          reminder_permission       : [],
          role_permission           : [],
          service_permission        : [],
          site_permission           : [],
          site_status_permission    : [],
          site_type_permission      : [],
          tenant_permission         : [],
          tracking_permission       : [],
          user_permission           : [],
          vendor_permission         : [],
          work_permission           : [],
        }
      }
      this.setState(new_state)
    }
  }

  render() {
    const {isModal, close, mode, is_process} = this.props

    return (
      <Modal isOpen={isModal} toggle={close} className="modal-lg">
        <ModalHeader toggle={close}>{mode === "modal_add" ? 'Add new' : 'Update'} Role</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-12">
              <label className="required">Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Type Name"
                value={this.state.name}
                onChange={(e) => this.setState({name: e.target.value})}
              />
            </div>
            <div className="form-group col-sm-12">
              <label className="required">Description</label>
              <textarea
                rows="5"
                className="form-control"
                placeholder="Enter Location Description"
                value={this.state.description}
                onChange={(e)=> this.setState({description: e.target.value})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Asset Permission</label>
              <Select
                multi       = {true}
                name        = "AssetPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.asset_permission}
                onChange    = {(val)=>this.setState({asset_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Asset Status Permission</label>
              <Select
                multi       = {true}
                name        = "AssetStatusPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.asset_status_permission}
                onChange    = {(val)=>this.setState({asset_status_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Asset Type Permission</label>
              <Select
                multi       = {true}
                name        = "AssetTypePermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.asset_type_permission}
                onChange    = {(val)=>this.setState({asset_type_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Booking Permission</label>
              <Select
                multi       = {true}
                name        = "BookingPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.booking_permission}
                onChange    = {(val)=>this.setState({booking_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Business Model Permission</label>
              <Select
                multi       = {true}
                name        = "BusinessModelPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.business_model_permission}
                onChange    = {(val)=>this.setState({business_model_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>City Coverage Permission</label>
              <Select
                multi       = {true}
                name        = "CityCoveragePermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.city_coverage_permission}
                onChange    = {(val)=>this.setState({city_coverage_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Confirmation Permission</label>
              <Select
                multi       = {true}
                name        = "ConfirmationPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.confirmation_permission}
                onChange    = {(val)=>this.setState({confirmation_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Contact Permission</label>
              <Select
                multi       = {true}
                name        = "ContactPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.contact_Permission}
                onChange    = {(val)=>this.setState({contact_Permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Departement Permission</label>
              <Select
                multi       = {true}
                name        = "DepartementPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.departement_permission}
                onChange    = {(val)=>this.setState({departement_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Location Permission</label>
              <Select
                multi       = {true}
                name        = "LocationPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.location_permission}
                onChange    = {(val)=>this.setState({location_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Message Permission</label>
              <Select
                multi       = {true}
                name        = "MessagePermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.message_permission}
                onChange    = {(val)=>this.setState({message_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Note Permission</label>
              <Select
                multi       = {true}
                name        = "NotePermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.note_permission}
                onChange    = {(val)=>this.setState({note_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Photo Permission</label>
              <Select
                multi       = {true}
                name        = "PhotoPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.photo_permission}
                onChange    = {(val)=>this.setState({photo_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Reminder Permission</label>
              <Select
                multi       = {true}
                name        = "ReminderPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.reminder_permission}
                onChange    = {(val)=>this.setState({reminder_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Role Permission</label>
              <Select
                multi       = {true}
                name        = "RolePermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.role_permission}
                onChange    = {(val)=>this.setState({role_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>ServicePermission</label>
              <Select
                multi       = {true}
                name        = "ServicePermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.service_permission}
                onChange    = {(val)=>this.setState({service_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Site Permission</label>
              <Select
                multi       = {true}
                name        = "SitePermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.site_permission}
                onChange    = {(val)=>this.setState({site_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Site Status Permission</label>
              <Select
                multi       = {true}
                name        = "SiteStatusPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.site_status_permission}
                onChange    = {(val)=>this.setState({site_status_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Site Type Permission</label>
              <Select
                multi       = {true}
                name        = "SiteTypePermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.site_type_permission}
                onChange    = {(val)=>this.setState({site_type_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Tenant Permission</label>
              <Select
                multi       = {true}
                name        = "TenantPermission"
                placeholder = "Type Permission"
                options     = {options_permission_tenant}
                value       = {this.state.tenant_permission}
                onChange    = {(val)=>this.setState({tenant_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Tracking Permission</label>
              <Select
                multi       = {true}
                name        = "TrackingPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.tracking_permission}
                onChange    = {(val)=>this.setState({tracking_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>User Permission</label>
              <Select
                multi       = {true}
                name        = "UserPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.user_permission}
                onChange    = {(val)=>this.setState({user_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Vendor Permission</label>
              <Select
                multi       = {true}
                name        = "VendorPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.vendor_permission}
                onChange    = {(val)=>this.setState({vendor_permission: val})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Work Permission</label>
              <Select
                multi       = {true}
                name        = "WorkPermission"
                placeholder = "Type Permission"
                options     = {options_permission}
                value       = {this.state.work_permission}
                onChange    = {(val)=>this.setState({work_permission: val})}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={close}>cancel</ButtonCancel>
          <ButtonValidation is_process={is_process} onClick={this.modalAction}>
            {mode === "modal_add" ? "Save" : "Update"}
          </ButtonValidation>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/user/role/helper/component/Modal.js